import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import Home from "@/pages/home/page";
import CategoryPage from "@/pages/category/page";
import ListPage from "@/pages/list/page";
import DetailPage from "@/pages/detail/page";
import SpecialPage from "@/pages/special/page";
import SearchPage from "@/pages/search/page";
import AboutPage from "@/pages/about/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category/:type", element: <CategoryPage /> },
      { path: "list/:category", element: <ListPage /> },
      { path: "detail/:id", element: <DetailPage /> },
      { path: "special", element: <SpecialPage /> },
      { path: "search", element: <SearchPage /> },
      { path: "about", element: <AboutPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;